<template>
    <div class="premium-content-thumbnail">
        <span class="icon">
            <GemFilledComponent />
        </span>
        <span class="label" v-if="showLabel">{{translate.product.premiumContent}}</span>
    </div>
</template>

<script>
import GemFilledComponent from "@/components/global/icons/GemFilledComponent.vue";

export default {
    components: {
        GemFilledComponent,
    },
    computed: {
        ...mapState(['translate']),
    },
    props: {
        showLabel: {
            type: Boolean,
            default: true
        },
    }
}
</script>
